<template>
  <div v-if="tags && tags.length">
    <summary-row
      v-for="(tag, tagIndex) of tags"
      :key="tagIndex"
      :text="tag.name + ' - ' + tag.category"
      :creation-status="getCreatedIds[createdIdsStoreName][tagIndex]"
    />
  </div>
</template>
<script>
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import { mapGetters } from "vuex";
import SummaryRow from "@/components/modules/administration/businessCreation/tabs/SummaryRow";

export default {
  name: "SummaryTagsAssign",
  components:{SummaryRow},
  props: {
    tags: {
      type: Array,
      default: () => [],
    },
    createdIdsStoreName: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapGetters(["getAllStoreInfo", "getCreatedIds"]),
  },
};
</script>

<style lang="scss" scoped>
.new-id {
  font-size: 11px;
  color: gray;
}

.error {
  color: red;
}

.ok {
  color: green;
}

.message-error {
  font-size: 16px;
  color: red;
  text-align: center;
  padding: 30px;
}

.delete-tab {
  color: red;
  font-weight: bold;
  margin-left: 5px;
  padding: 2px 5px;
  font-size: 15px;
  transition: 0.3s;

  &:hover {
    font-size: 13px;
  }
}
</style>
